<template>
    <div class="layout" v-if="isOnline">
        <top-menu />
        <div class="content">
            <transition name="fade">
                <router-view></router-view>
            </transition>
        </div>
        <!--<foo v-if="$route.name !== '404'" />-->
    </div>
    <offline v-else />
</template>

<style lang="scss">
@import "../../styles/vars.scss";
.bg-main {
    background: $color--main;
}
.bg-light {
    background: $color--light;
}
.text-main {
    color: $color--main;
}
</style>

<script>
    export default {
        name: '',
        data () {
            return {
                isOnline: true
            }
        },
        mounted () {
            this.updateStatus()
            this.$store.state.loaded = false
            setTimeout(() => {
                this.$store.state.loaded = true
            }, 2000)
        },
        components: {
            'offline': require('@/components/core/offline'),
            'top-menu': require('@/components/layout/menu'),
            'foo': require('@/components/layout/footer'),
            'loader': require('@/components/layout/loader'),
            'login': require('@/components/core/login')
        },
        methods: {
            updateStatus: function () {
                if (typeof window.navigator.onLine === 'undefined') {
                    this.isOnline = true
                } else {
                    this.isOnline = window.navigator.onLine
                }
                window.addEventListener('online', this.updateStatus)
                window.addEventListener('offline', this.updateStatus)
            },
            initialize () {
                // this.$store.state.loaded = false
                console.log('hejsa')
                this.$store.state.loaded = false
                setTimeout(() => {
                    this.$store.state.loaded = true
                }, 2000)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// layout.vue?a8fefbfc